import React from 'react';
import { Button } from '@assets/components/Button/Button';

import Logo from '@assets/images/logo_dark.svg';

interface HeaderProps {
  showNav: boolean;
}

export function Header({ showNav = true }: HeaderProps) {
  return (
    <header className="betterMood__header">
      <a href="/">
        <img src={Logo} height="39" width="100" alt="Better Mood" />
      </a>
      <div>
        {showNav && (
          <>
            <Button href="/app/login" flat transparent disposable>
              Sign in
            </Button>
            <Button href="/" flat primary pill animate>
              Get started
            </Button>
          </>
        )}
      </div>
      {/* 
      <div>
        <Button link disposable href={signInURL}>
          Sign in
        </Button>
        <Button pill primary href={homeURL}>
          Get started
        </Button>
      </div> */}
    </header>
  );
}
